import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    color: PropTypes.string,
    fr: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    fr: false,
    className: null,
};

const FMCIcon = ({ color, fr, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="576px"
        height="225.3px"
        viewBox="0 0 576 225.3"
        xmlSpace="preserve"
        role="img"
        className={className}
    >
        {fr ? (
            <g>
                <path
                    fill={color}
                    d="M92.6,27.1v57.4l-64,53.2l71,59.1v-57.4l64-53.2L92.6,27.1z M92.6,136.1v45.7l-53-44l60-49.9V42.2l53,44L92.6,136.1z"
                />
                <g>
                    <path
                        fill={color}
                        d="M412.1,159.7v3.9c-0.8,1.5-2.7,3.8-6.7,3.8c-4,0-6.1-2.3-6.9-4v-11.1c0.8-1.7,2.8-4,6.9-4c4,0,6,2.3,6.7,3.8v3.6h-3.5
				v-2.7c-0.4-1-1.5-1.9-3.3-1.9c-1.7,0-2.8,0.9-3.3,1.9v9.7c0.4,1,1.5,1.9,3.3,1.9c1.7,0,2.8-0.9,3.3-1.9v-2.9H412.1z"
                    />
                    <path
                        fill={color}
                        d="M414.5,164.9l4.8-16.3h5.3l4.8,16.3v2h-3.2l-1.4-5.3h-5.9l-1.4,5.3h-2.9V164.9z M419.6,158.9h4.4l-2-7.3h-0.4
				L419.6,158.9z"
                    />
                    <path
                        fill={color}
                        d="M432.5,148.5h4.2l6.1,12.4h0.4v-12.4h3.4v18.4h-4.2l-6.1-12.4h-0.5v12.4h-3.4V148.5z"
                    />
                    <path
                        fill={color}
                        d="M449.8,164.9l4.8-16.3h5.3l4.8,16.3v2h-3.2l-1.4-5.3h-5.9l-1.4,5.3h-2.9V164.9z M454.9,158.9h4.4l-2-7.3h-0.4
				L454.9,158.9z"
                    />
                    <path
                        fill={color}
                        d="M481.3,163.3c-0.8,1.7-2.7,3.6-6.1,3.6h-7.3v-18.4h7.3c3.4,0,5.4,1.9,6.1,3.6V163.3z M477.7,153c-0.4-1-1.5-1.8-3.3-1.8
				h-3v13h3c1.7,0,2.8-0.8,3.3-1.8V153z"
                    />
                    <path
                        fill={color}
                        d="M483.7,164.9l4.8-16.3h5.3l4.8,16.3v2h-3.2l-1.4-5.3h-5.9l-1.4,5.3h-2.9V164.9z M488.8,158.9h4.4l-2-7.3h-0.4
				L488.8,158.9z"
                    />
                    <path
                        fill={color}
                        d="M398.8,178.4h4.9l3.9,9.1h0.4l3.8-9.1h4.8v18.4h-3.4v-13.3h-0.5l-3.9,9.3h-2.3l-3.9-9.3h-0.5v13.3h-3.4V178.4z"
                    />
                    <path
                        fill={color}
                        d="M420.7,178.4h11.1v2.7h-7.5v4.9h7v2.7h-7v5.4h7.7v2.7h-11.3V178.4z"
                    />
                    <path
                        fill={color}
                        d="M449,193.1c-0.8,1.7-2.7,3.6-6.1,3.6h-7.3v-18.4h7.3c3.4,0,5.4,1.9,6.1,3.6V193.1z M445.4,182.9c-0.4-1-1.5-1.8-3.3-1.8
				h-3v13h3c1.7,0,2.8-0.8,3.3-1.8V182.9z"
                    />
                    <path fill={color} d="M452.8,178.4h3.6v18.4h-3.6V178.4z" />
                    <path
                        fill={color}
                        d="M459.5,194.7l4.8-16.3h5.3l4.8,16.3v2h-3.2l-1.4-5.3h-5.9l-1.4,5.3h-2.9V194.7z M464.6,188.7h4.4l-2-7.3h-0.4
				L464.6,188.7z"
                    />
                    <path
                        fill={color}
                        d="M483.2,178.4h10.9v2.7h-7.3v5h6.9v2.7h-6.9v8h-3.6V178.4z"
                    />
                    <path
                        fill={color}
                        d="M511.2,178.4v14.8c-0.8,1.7-2.8,4-6.9,4c-4,0-6.1-2.3-6.8-4v-14.8h3.6v14c0.4,1,1.5,1.9,3.2,1.9c1.7,0,2.8-0.9,3.3-1.9
				v-14H511.2z"
                    />
                    <path
                        fill={color}
                        d="M515.2,178.4h4.2l6.1,12.4h0.4v-12.4h3.4v18.4h-4.2l-6.1-12.4h-0.5v12.4h-3.4V178.4z"
                    />
                    <path
                        fill={color}
                        d="M546.9,193.1c-0.8,1.7-2.7,3.6-6.1,3.6h-7.3v-18.4h7.3c3.4,0,5.4,1.9,6.1,3.6V193.1z M543.3,182.9
				c-0.4-1-1.5-1.8-3.3-1.8h-3v13h3c1.7,0,2.8-0.8,3.3-1.8V182.9z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M133.6,148.5h10.9v2.7h-7.3v5h6.9v2.7h-6.9v8h-3.6V148.5z"
                    />
                    <path
                        fill={color}
                        d="M147.4,152.2c0.8-1.7,2.8-4,6.9-4c4,0,6.1,2.3,6.9,4v11.1c-0.8,1.7-2.8,4-6.9,4c-4,0-6.1-2.3-6.9-4V152.2z M151,162.6
				c0.4,1,1.5,1.9,3.3,1.9c1.7,0,2.8-0.9,3.3-1.9v-9.7c-0.4-1-1.5-1.9-3.3-1.9c-1.7,0-2.8,0.9-3.3,1.9V162.6z"
                    />
                    <path
                        fill={color}
                        d="M164.9,148.5h4.2l6.1,12.4h0.4v-12.4h3.4v18.4h-4.2l-6.1-12.4h-0.5v12.4h-3.4V148.5z"
                    />
                    <path
                        fill={color}
                        d="M196.6,163.3c-0.8,1.7-2.7,3.6-6.1,3.6h-7.3v-18.4h7.3c3.4,0,5.4,1.9,6.1,3.6V163.3z M193,153c-0.4-1-1.6-1.8-3.3-1.8h-3
				v13h3c1.7,0,2.8-0.8,3.3-1.8V153z"
                    />
                    <path
                        fill={color}
                        d="M199.9,161.1h3.5v1.8c0.4,0.8,1.4,1.7,3.1,1.7c1.7,0,2.7-0.9,3.1-1.7v-2.1c-0.3-0.7-0.9-1.2-2.5-1.6l-1.6-0.4
				c-3.8-0.9-4.9-2.1-5.6-3.3v-3.9c0.7-1.3,2.5-3.5,6.6-3.5c4,0,5.9,2.3,6.6,3.5v2.5h-3.5v-1.5c-0.4-0.8-1.4-1.7-3.1-1.7
				c-1.7,0-2.7,0.9-3.1,1.7v1.7c0.4,0.7,0.9,1.2,2.6,1.5l1.5,0.4c3.8,0.9,4.9,2.1,5.6,3.3v4.3c-0.7,1.3-2.5,3.5-6.6,3.5
				c-4,0-5.9-2.3-6.6-3.5V161.1z"
                    />
                    <path
                        fill={color}
                        d="M236.4,163.3c-0.8,1.7-2.7,3.6-6.1,3.6h-7.3v-18.4h7.3c3.4,0,5.4,1.9,6.1,3.6V163.3z M232.8,153c-0.4-1-1.6-1.8-3.3-1.8
				h-3v13h3c1.7,0,2.8-0.8,3.3-1.8V153z"
                    />
                    <path
                        fill={color}
                        d="M240.2,148.5h11.1v2.7h-7.5v4.9h7v2.7h-7v5.4h7.7v2.7h-11.3V148.5z"
                    />
                    <path
                        fill={color}
                        d="M254.6,161.1h3.5v1.8c0.4,0.8,1.4,1.7,3.1,1.7c1.7,0,2.7-0.9,3.1-1.7v-2.1c-0.3-0.7-0.9-1.2-2.5-1.6l-1.6-0.4
				c-3.8-0.9-4.9-2.1-5.6-3.3v-3.9c0.7-1.3,2.5-3.5,6.6-3.5s5.9,2.3,6.6,3.5v2.5h-3.5v-1.5c-0.4-0.8-1.4-1.7-3.1-1.7
				c-1.7,0-2.7,0.9-3.1,1.7v1.7c0.4,0.7,0.9,1.2,2.6,1.5l1.5,0.4c3.8,0.9,4.9,2.1,5.6,3.3v4.3c-0.7,1.3-2.5,3.5-6.6,3.5
				s-5.9-2.3-6.6-3.5V161.1z"
                    />
                    <path
                        fill={color}
                        d="M277.5,148.6h4.9l3.9,9.1h0.4l3.8-9.1h4.8V167h-3.4v-13.3h-0.5l-3.9,9.3h-2.3l-3.9-9.3h-0.5V167h-3.4V148.6z"
                    />
                    <path
                        fill={color}
                        d="M299.4,148.6h11.1v2.7H303v4.9h7v2.7h-7v5.4h7.7v2.7h-11.3V148.6z M303.5,146.9l1.5-3.7h3.2v1.4l-2.1,2.7h-2.6V146.9z"
                    />
                    <path
                        fill={color}
                        d="M327.7,163.3c-0.8,1.7-2.7,3.6-6.1,3.6h-7.3v-18.4h7.3c3.4,0,5.4,1.9,6.1,3.6V163.3z M324.1,153c-0.4-1-1.6-1.8-3.3-1.8
				h-3v13h3c1.7,0,2.8-0.8,3.3-1.8V153z"
                    />
                    <path fill={color} d="M331.5,148.6h3.6V167h-3.6V148.6z" />
                    <path
                        fill={color}
                        d="M338.3,164.9l4.8-16.3h5.3l4.8,16.3v2H350l-1.4-5.3h-5.9l-1.4,5.3h-2.9V164.9z M343.4,158.9h4.4l-2-7.3h-0.4L343.4,158.9
				z"
                    />
                    <path
                        fill={color}
                        d="M355.6,161.1h3.5v1.8c0.4,0.8,1.4,1.7,3.1,1.7c1.7,0,2.7-0.9,3.1-1.7v-2.1c-0.3-0.7-0.9-1.2-2.5-1.6l-1.6-0.4
				c-3.8-0.9-4.9-2.1-5.6-3.3v-3.9c0.7-1.3,2.5-3.5,6.6-3.5c4,0,5.9,2.3,6.6,3.5v2.5h-3.5v-1.5c-0.4-0.8-1.4-1.7-3.1-1.7
				c-1.7,0-2.7,0.9-3.1,1.7v1.7c0.4,0.7,0.9,1.2,2.6,1.5l1.5,0.4c3.8,0.9,4.9,2.1,5.6,3.3v4.3c-0.7,1.3-2.5,3.5-6.6,3.5
				c-4,0-5.9-2.3-6.6-3.5V161.1z"
                    />
                    <path
                        fill={color}
                        d="M147,193c-0.8,1.7-2.7,3.6-6.1,3.6h-7.3v-18.4h7.3c3.4,0,5.4,1.9,6.1,3.6V193z M143.4,182.7c-0.4-1-1.6-1.8-3.3-1.8h-3
				v13h3c1.7,0,2.8-0.8,3.3-1.8V182.7z"
                    />
                    <path
                        fill={color}
                        d="M164.4,178.2V193c-0.8,1.7-2.8,4-6.9,4c-4,0-6.1-2.3-6.8-4v-14.8h3.6v14.1c0.4,1,1.5,1.9,3.2,1.9c1.7,0,2.8-0.9,3.3-1.9
				v-14.1H164.4z"
                    />
                    <path
                        fill={color}
                        d="M187.7,189.3v3.9c-0.8,1.5-2.7,3.8-6.7,3.8c-4,0-6.1-2.3-6.9-4v-11.1c0.8-1.7,2.8-4,6.9-4c4,0,6,2.3,6.7,3.8v3.7h-3.5
				v-2.7c-0.4-1-1.5-1.9-3.3-1.9c-1.7,0-2.8,0.9-3.3,1.9v9.7c0.4,1,1.5,1.9,3.3,1.9c1.7,0,2.8-0.9,3.3-1.9v-2.9H187.7z"
                    />
                    <path
                        fill={color}
                        d="M190,194.6l4.8-16.3h5.3l4.8,16.3v2h-3.2l-1.4-5.3h-5.9l-1.4,5.3H190V194.6z M195.1,188.6h4.4l-2-7.3h-0.4L195.1,188.6z"
                    />
                    <path
                        fill={color}
                        d="M208.1,178.2h4.2l6.1,12.4h0.4v-12.4h3.4v18.4H218l-6.1-12.4h-0.5v12.4h-3.4V178.2z"
                    />
                    <path
                        fill={color}
                        d="M225.4,194.6l4.8-16.3h5.3l4.8,16.3v2h-3.2l-1.4-5.3h-5.9l-1.4,5.3h-2.9V194.6z M230.5,188.6h4.4l-2-7.3h-0.4
				L230.5,188.6z"
                    />
                    <path
                        fill={color}
                        d="M256.9,193c-0.8,1.7-2.7,3.6-6.1,3.6h-7.3v-18.4h7.3c3.4,0,5.4,1.9,6.1,3.6V193z M253.3,182.7c-0.4-1-1.6-1.8-3.3-1.8h-3
				v13h3c1.7,0,2.8-0.8,3.3-1.8V182.7z"
                    />
                    <path
                        fill={color}
                        d="M259.3,194.6l4.8-16.3h5.3l4.8,16.3v2H271l-1.4-5.3h-5.9l-1.4,5.3h-2.9V194.6z M264.4,188.6h4.4l-2-7.3h-0.4L264.4,188.6
				z"
                    />
                </g>
            </g>
        ) : (
            <g>
                <path
                    fill={color}
                    d="M92.6,27.1v57.4l-64,53.2l71,59.1v-57.4l64-53.2L92.6,27.1z M92.6,136.1v45.7l-53-44l60-49.9V42.2l53,44L92.6,136.1z"
                />
                <g>
                    <g>
                        <path
                            fill={color}
                            d="M147.1,159.7v3.9c-0.8,1.5-2.7,3.8-6.7,3.8c-4,0-6.1-2.3-6.9-4v-11.1c0.8-1.7,2.8-4,6.9-4c4,0,6,2.3,6.7,3.8v3.6h-3.5
					v-2.7c-0.4-1-1.5-1.9-3.3-1.9c-1.7,0-2.8,0.9-3.3,1.9v9.7c0.4,1,1.5,1.9,3.3,1.9c1.7,0,2.8-0.9,3.3-1.9v-2.9H147.1z"
                        />
                        <path
                            fill={color}
                            d="M149.5,164.9l4.8-16.3h5.3l4.8,16.3v2h-3.2l-1.4-5.3h-5.9l-1.4,5.3h-2.9V164.9z M154.6,158.9h4.4l-2-7.3h-0.4
					L154.6,158.9z"
                        />
                        <path
                            fill={color}
                            d="M167.5,148.5h4.2l6.1,12.4h0.4v-12.4h3.4v18.4h-4.2l-6.1-12.4h-0.5v12.4h-3.4V148.5z"
                        />
                        <path
                            fill={color}
                            d="M184.8,164.9l4.8-16.3h5.3l4.8,16.3v2h-3.2l-1.4-5.3h-5.9l-1.4,5.3h-2.9V164.9z M189.9,158.9h4.4l-2-7.3h-0.4
					L189.9,158.9z"
                        />
                        <path
                            fill={color}
                            d="M216.3,163.3c-0.8,1.7-2.7,3.6-6.1,3.6h-7.3v-18.4h7.3c3.4,0,5.4,1.9,6.1,3.6V163.3z M212.7,153c-0.4-1-1.5-1.8-3.3-1.8
					h-3v13h3c1.7,0,2.8-0.8,3.3-1.8V153z"
                        />
                        <path
                            fill={color}
                            d="M218.8,164.9l4.8-16.3h5.3l4.8,16.3v2h-3.2l-1.4-5.3h-5.9l-1.4,5.3h-2.9V164.9z M223.9,158.9h4.4l-2-7.3h-0.4
					L223.9,158.9z"
                        />
                        <path
                            fill={color}
                            d="M133.8,178.4h4.9l3.9,9.1h0.4l3.8-9.1h4.8v18.4h-3.4v-13.3h-0.5l-3.9,9.3h-2.3l-3.9-9.3h-0.5v13.3h-3.4V178.4z"
                        />
                        <path
                            fill={color}
                            d="M155.7,178.4h11.1v2.7h-7.5v4.9h7v2.7h-7v5.4h7.7v2.7h-11.3V178.4z"
                        />
                        <path
                            fill={color}
                            d="M184,193.1c-0.8,1.7-2.7,3.6-6.1,3.6h-7.3v-18.4h7.3c3.4,0,5.4,1.9,6.1,3.6V193.1z M180.4,182.9c-0.4-1-1.5-1.8-3.3-1.8
					h-3v13h3c1.7,0,2.8-0.8,3.3-1.8V182.9z"
                        />
                        <path fill={color} d="M187.8,178.4h3.6v18.4h-3.6V178.4z" />
                        <path
                            fill={color}
                            d="M194.5,194.7l4.8-16.3h5.3l4.8,16.3v2h-3.2l-1.4-5.3h-5.9l-1.4,5.3h-2.9V194.7z M199.6,188.7h4.4l-2-7.3h-0.4
					L199.6,188.7z"
                        />
                        <path
                            fill={color}
                            d="M218.2,178.4h10.9v2.7h-7.3v5h6.9v2.7h-6.9v8h-3.6V178.4z"
                        />
                        <path
                            fill={color}
                            d="M246.2,178.4v14.8c-0.8,1.7-2.8,4-6.9,4c-4,0-6.1-2.3-6.8-4v-14.8h3.6v14c0.4,1,1.5,1.9,3.2,1.9c1.7,0,2.8-0.9,3.3-1.9
					v-14H246.2z"
                        />
                        <path
                            fill={color}
                            d="M250.2,178.4h4.2l6.1,12.4h0.4v-12.4h3.4v18.4h-4.2l-6.1-12.4h-0.5v12.4h-3.4V178.4z"
                        />
                        <path
                            fill={color}
                            d="M281.9,193.1c-0.8,1.7-2.7,3.6-6.1,3.6h-7.3v-18.4h7.3c3.4,0,5.4,1.9,6.1,3.6V193.1z M278.3,182.9
					c-0.4-1-1.5-1.8-3.3-1.8h-3v13h3c1.7,0,2.8-0.8,3.3-1.8V182.9z"
                        />
                    </g>
                    <path
                        fill={color}
                        d="M312.2,148.5h10.9v2.7h-7.3v5h6.9v2.7h-6.9v8h-3.6V148.5z"
                    />
                    <path
                        fill={color}
                        d="M326.1,152.2c0.8-1.7,2.8-4,6.9-4c4,0,6.1,2.3,6.9,4v11.1c-0.8,1.7-2.8,4-6.9,4c-4,0-6.1-2.3-6.9-4V152.2z M329.7,162.6
				c0.4,1,1.5,1.9,3.3,1.9c1.7,0,2.8-0.9,3.3-1.9v-9.7c-0.4-1-1.5-1.9-3.3-1.9c-1.7,0-2.8,0.9-3.3,1.9V162.6z"
                    />
                    <path
                        fill={color}
                        d="M343.6,148.5h4.2l6.1,12.4h0.4v-12.4h3.4v18.4h-4.2l-6.1-12.4H347v12.4h-3.4V148.5z"
                    />
                    <path
                        fill={color}
                        d="M375.3,163.3c-0.8,1.7-2.7,3.6-6.1,3.6h-7.3v-18.4h7.3c3.4,0,5.4,1.9,6.1,3.6V163.3z M371.7,153c-0.4-1-1.6-1.8-3.3-1.8
				h-3v13h3c1.7,0,2.8-0.8,3.3-1.8V153z"
                    />
                    <path
                        fill={color}
                        d="M378.6,161.1h3.5v1.8c0.4,0.8,1.4,1.7,3.1,1.7c1.7,0,2.7-0.9,3.1-1.7v-2.1c-0.3-0.7-0.9-1.2-2.5-1.6l-1.6-0.4
				c-3.8-0.9-4.9-2.1-5.6-3.3v-3.9c0.7-1.3,2.5-3.5,6.6-3.5c4,0,5.9,2.3,6.6,3.5v2.5h-3.5v-1.5c-0.4-0.8-1.4-1.7-3.1-1.7
				c-1.7,0-2.7,0.9-3.1,1.7v1.7c0.4,0.7,0.9,1.2,2.6,1.5l1.5,0.4c3.8,0.9,4.9,2.1,5.6,3.3v4.3c-0.7,1.3-2.5,3.5-6.6,3.5
				c-4,0-5.9-2.3-6.6-3.5V161.1z"
                    />
                    <path
                        fill={color}
                        d="M415.1,163.3c-0.8,1.7-2.7,3.6-6.1,3.6h-7.3v-18.4h7.3c3.4,0,5.4,1.9,6.1,3.6V163.3z M411.5,153c-0.4-1-1.6-1.8-3.3-1.8
				h-3v13h3c1.7,0,2.8-0.8,3.3-1.8V153z"
                    />
                    <path
                        fill={color}
                        d="M418.9,148.5H430v2.7h-7.5v4.9h7v2.7h-7v5.4h7.7v2.7h-11.3V148.5z"
                    />
                    <path
                        fill={color}
                        d="M433.3,161.1h3.5v1.8c0.4,0.8,1.4,1.7,3.1,1.7c1.7,0,2.7-0.9,3.1-1.7v-2.1c-0.3-0.7-0.9-1.2-2.5-1.6l-1.6-0.4
				c-3.8-0.9-4.9-2.1-5.6-3.3v-3.9c0.7-1.3,2.5-3.5,6.6-3.5c4,0,5.9,2.3,6.6,3.5v2.5H443v-1.5c-0.4-0.8-1.4-1.7-3.1-1.7
				c-1.7,0-2.7,0.9-3.1,1.7v1.7c0.4,0.7,0.9,1.2,2.6,1.5l1.5,0.4c3.8,0.9,4.9,2.1,5.6,3.3v4.3c-0.7,1.3-2.5,3.5-6.6,3.5
				c-4,0-5.9-2.3-6.6-3.5V161.1z"
                    />
                    <path
                        fill={color}
                        d="M456.2,148.6h4.9l3.9,9.1h0.4l3.8-9.1h4.8V167h-3.4v-13.3h-0.5l-3.9,9.3H464l-3.9-9.3h-0.5V167h-3.4V148.6z"
                    />
                    <path
                        fill={color}
                        d="M478.1,148.6h11.1v2.7h-7.5v4.9h7v2.7h-7v5.4h7.7v2.7h-11.3V148.6z M482.1,146.9l1.5-3.7h3.2v1.4l-2.1,2.7h-2.6V146.9z"
                    />
                    <path
                        fill={color}
                        d="M506.4,163.3c-0.8,1.7-2.7,3.6-6.1,3.6H493v-18.4h7.3c3.4,0,5.4,1.9,6.1,3.6V163.3z M502.8,153c-0.4-1-1.6-1.8-3.3-1.8
				h-3v13h3c1.7,0,2.8-0.8,3.3-1.8V153z"
                    />
                    <path fill={color} d="M510.2,148.6h3.6V167h-3.6V148.6z" />
                    <path
                        fill={color}
                        d="M517,164.9l4.8-16.3h5.3l4.8,16.3v2h-3.2l-1.4-5.3h-5.9l-1.4,5.3H517V164.9z M522.1,158.9h4.4l-2-7.3h-0.4L522.1,158.9z"
                    />
                    <path
                        fill={color}
                        d="M534.2,161.1h3.5v1.8c0.4,0.8,1.4,1.7,3.1,1.7c1.7,0,2.7-0.9,3.1-1.7v-2.1c-0.3-0.7-0.9-1.2-2.5-1.6l-1.6-0.4
				c-3.8-0.9-4.9-2.1-5.6-3.3v-3.9c0.7-1.3,2.5-3.5,6.6-3.5c4,0,5.9,2.3,6.6,3.5v2.5H544v-1.5c-0.4-0.8-1.4-1.7-3.1-1.7
				c-1.7,0-2.7,0.9-3.1,1.7v1.7c0.4,0.7,0.9,1.2,2.6,1.5l1.5,0.4c3.8,0.9,4.9,2.1,5.6,3.3v4.3c-0.7,1.3-2.5,3.5-6.6,3.5
				c-4,0-5.9-2.3-6.6-3.5V161.1z"
                    />
                    <path
                        fill={color}
                        d="M325.7,193c-0.8,1.7-2.7,3.6-6.1,3.6h-7.3v-18.4h7.3c3.4,0,5.4,1.9,6.1,3.6V193z M322.1,182.7c-0.4-1-1.6-1.8-3.3-1.8h-3
				v13h3c1.7,0,2.8-0.8,3.3-1.8V182.7z"
                    />
                    <path
                        fill={color}
                        d="M343.1,178.2V193c-0.8,1.7-2.8,4-6.9,4c-4,0-6.1-2.3-6.8-4v-14.8h3.6v14.1c0.4,1,1.5,1.9,3.2,1.9c1.7,0,2.8-0.9,3.3-1.9
				v-14.1H343.1z"
                    />
                    <path
                        fill={color}
                        d="M366.4,189.3v3.9c-0.8,1.5-2.7,3.8-6.7,3.8c-4,0-6.1-2.3-6.9-4v-11.1c0.8-1.7,2.8-4,6.9-4c4,0,6,2.3,6.7,3.8v3.7h-3.5
				v-2.7c-0.4-1-1.5-1.9-3.3-1.9c-1.7,0-2.8,0.9-3.3,1.9v9.7c0.4,1,1.5,1.9,3.3,1.9c1.7,0,2.8-0.9,3.3-1.9v-2.9H366.4z"
                    />
                    <path
                        fill={color}
                        d="M368.7,194.6l4.8-16.3h5.3l4.8,16.3v2h-3.2l-1.4-5.3h-5.9l-1.4,5.3h-2.9V194.6z M373.8,188.6h4.4l-2-7.3h-0.4
				L373.8,188.6z"
                    />
                    <path
                        fill={color}
                        d="M386.8,178.2h4.2l6.1,12.4h0.4v-12.4h3.4v18.4h-4.2l-6.1-12.4h-0.5v12.4h-3.4V178.2z"
                    />
                    <path
                        fill={color}
                        d="M404.1,194.6l4.8-16.3h5.3l4.8,16.3v2h-3.2l-1.4-5.3h-5.9l-1.4,5.3h-2.9V194.6z M409.2,188.6h4.4l-2-7.3h-0.4
				L409.2,188.6z"
                    />
                    <path
                        fill={color}
                        d="M435.6,193c-0.8,1.7-2.7,3.6-6.1,3.6h-7.3v-18.4h7.3c3.4,0,5.4,1.9,6.1,3.6V193z M432,182.7c-0.4-1-1.6-1.8-3.3-1.8h-3
				v13h3c1.7,0,2.8-0.8,3.3-1.8V182.7z"
                    />
                    <path
                        fill={color}
                        d="M438,194.6l4.8-16.3h5.3l4.8,16.3v2h-3.2l-1.4-5.3h-5.9l-1.4,5.3H438V194.6z M443.1,188.6h4.4l-2-7.3h-0.4L443.1,188.6z"
                    />
                </g>
            </g>
        )}
    </svg>
);

FMCIcon.propTypes = propTypes;
FMCIcon.defaultProps = defaultProps;

export default FMCIcon;
